// log some application information
import pkg from "../package.json";
console.log(`${pkg.name} ${pkg.version}`);
import * as React from "react";
import * as ReactDom from "react-dom";
console.log(`using react ${React.version}, react-dom ${ReactDom.version}` );

// React DevTools workaround for React 18+
const hook = (window as any).__REACT_DEVTOOLS_GLOBAL_HOOK__;
if (hook && hook.renderers) {
    hook.renderers.forEach((r: any) => {
        if (!r.version) r.version = React.version;
    });
}

import {StrictMode} from 'react'
import {createRoot} from 'react-dom/client'
import './index.css'
import App from "./App.tsx";

/**
 * Render the application.
 */
const el = document.getElementById('root')
createRoot(el!).render(
    <StrictMode>
        <App/>
    </StrictMode>,
)
